import { Component, ElementRef, ViewEncapsulation, viewChild } from '@angular/core';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from '../../../animations/index';

@Component({
  selector: 'app-content-cabinet',
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()],
  host: {
    role: 'main',
    id: 'main-content'
  }
})
export class ContentCabinetComponent {
  // A negative tabindex on the shadow host would drop the whole page from the
  // Tab order, so focus lands on an empty anchor at the top of the region.
  private readonly anchor = viewChild.required<ElementRef<HTMLElement>>('anchor');

  /** Moves focus to the start of the page region (skip link, after navigation). */
  focus(): void {
    this.anchor().nativeElement.focus({ preventScroll: true });
  }
}
